import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js"
import { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { setRefetchCard } from "../../../redux/recueslice/addressSlice"
import "../../../Style/QuickViewBuiding/QuickViewBuilding.scss"

export default function CheckoutForm({
  clientSecret,
  customerName,
  setShowForm,
}) {
  const stripe = useStripe()
  const elements = useElements()
  const dispatch = useDispatch()

  const [message, setMessage] = useState(null)
  const [isProcessing, setIsProcessing] = useState(false)
  const [error, setError] = useState(null)
  const getAdminId = localStorage.getItem("adminId")

  const fetchUpdatedData = async () => {
    try {
      // Replace this with your actual API call
      const response = await fetch("/api/updated-data", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
      const data = await response.json()
    } catch (error) {}
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!stripe || !elements) {
      return
    }

    setIsProcessing(true)

    const cardElement = elements.getElement(CardElement)
    const { error } = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          name: customerName,
        },
      },
    })

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message)
      } else {
        setMessage("An unexpected error occurred.")
      }
    } else {
      dispatch(setRefetchCard())
      setShowForm(false)
      await fetchUpdatedData()
    }

    setIsProcessing(false)
  }

  return (
    <div>
      <form
        id="payment-form"
        className="shadow p-3 FormCardBank"
        onSubmit={handleSubmit}
      >
        <CardElement />
        <button
          disabled={isProcessing || !stripe || !elements}
          className="mt-5"
          id="submit"
          style={{
            border: "none",
            backgroundColor: "#28a745",
            color: "#fff",
            padding: "5px",
            borderRadius: "2px",
            marginLeft: "40%",
          }}
        >
          <span id="button-text">
            {isProcessing ? "Processing ..." : "Save Card"}
          </span>
        </button>
        {/* Show any error or success messages */}
        {message && <div id="payment-message">{message}</div>}
      </form>
    </div>
  )
}

